export { default } from './inbox-filled'
